/**
 * Background colors - deep dark palette
 */
export const mainColor = {
  darkest: "#0a0e17",
  dark: "#0d1117",
  normal: "#161b22",
  light: "#1c2333",
}

/**
 * Neon accent colors
 */
export const accentColor = {
  primary: "#00fff2",    // cyan
  secondary: "#39ff14",  // neon green
  tertiary: "#bd93f9",   // purple
  warm: "#ff6e40",       // orange
}

/**
 * Text colors
 */
export const textColor = {
  primary: "#e6edf3",
  secondary: "#8b949e",
  dim: "#484f58",
  caption: "#00fff2",
  basetext: "#e6edf3",
}

/**
 * Utility colors
 */
export const grayColor = {
  border: "#30363d",
  selection: "#1a3a5c",
  surface: "#21262d",
}
